import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { map as _map, set as _set, filter as _filter, isArray as _isArray, get as _get, some as _some, every as _every } from 'lodash';
/**
 *
 * @param data {array}
 * @param valueSourcePaths {array|string}
 * @param serieSourcePath {string}
 * @param allValuesNull {boolean} if true, all values has to be null to filter the item out
 * @return {*}
 */

function filterDataWithNullValue(data, valueSourcePaths, serieSourcePath, allValuesNull) {
  if (!serieSourcePath) {
    return filterData(data, valueSourcePaths, allValuesNull);
  } else {
    var withoutNullValues = _map(data, function (item) {
      var data = _get(item, serieSourcePath);

      var filteredData = filterData(data, valueSourcePaths);
      return _set(_objectSpread({}, item), serieSourcePath, filteredData);
    });

    return _filter(withoutNullValues, function (item) {
      var data = _get(item, serieSourcePath);

      return data && data.length !== 0;
    });
  }
}

function isNull(val) {
  return !val && val !== 0;
}

function filterData(data, valueSourcePaths, allValuesNull) {
  return _filter(data, function (item) {
    if (_isArray(valueSourcePaths)) {
      var nullN = allValuesNull ? _every : _some;
      return !nullN(valueSourcePaths, function (path) {
        return isNull(_get(item, path));
      });
    } else {
      return !isNull(_get(item, valueSourcePaths));
    }
  });
}

export default {
  filterDataWithNullValue: filterDataWithNullValue
};